export default {
  user: state => state,
  loading: state => state.loading,
  token: state => state.token,
  error: state => state.error,
  refreshError: state => state.refreshError,
  exp: state => state.model.expire, 
};
